import { render } from "./HeaderNavigationLink.vue?vue&type=template&id=34fcb58a&scoped=true"
import script from "./HeaderNavigationLink.vue?vue&type=script&lang=js"
export * from "./HeaderNavigationLink.vue?vue&type=script&lang=js"

import "./HeaderNavigationLink.vue?vue&type=style&index=0&id=34fcb58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fcb58a"]])

export default __exports__